<div class="flex ml-1">
  <div *ngIf="order?.loHiPreloadPaused" matTooltip="Preload - Paused">💤</div>
  <div *ngIf="order?.loHiPreloadActive" matTooltip="Preload - Resumed">▶️</div>
</div>
